import { DatePicker, Form } from "antd";
import React, { useState } from "react";

const SubjectAncLmpDate: React.FC = () => {
  return (
    <Form.Item
      name={["subjectAnc", "lmpDate"]}
      label="LMP Date"
      rules={[
        {
          required: true,
          message: "LMP Date is required.",
        },
      ]}
    >
      <DatePicker
        style={{ width: "100%" }}
        allowClear={false}
        format={"DD-MMM-YYYY"}
      />
    </Form.Item>
  );
};

export default SubjectAncLmpDate;
